import React, { useEffect, useState } from "react";
import "./styles/Auth.css";
import Login from "./childComponents/Login";
import Signup from "./childComponents/Signup";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../dataManagement/uiDb/UiDb";
import { closeAuth } from "../../../dataManagement/uiDb/GeneralDb";
import ForgotPassword from "./childComponents/ForgotPassword";
import { FiArrowLeft } from "react-icons/fi";
import { isIosWebView } from "../../../services/helpers/platform";

const Auth: React.FC = () => {
  const generalDb = useSelector((state: RootState) => state.general);
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState<
    "login" | "signup" | "forgotpassword"
  >("login");

  // Individual user signup is not offered inside the iOS wrapper (App Store
  // policy). On iOS the auth modal is login-only: the Sign Up toggle is hidden
  // and the signup form is never rendered even if the tab is somehow set.
  const blockSignup = isIosWebView();

  useEffect(() => {
    if (generalDb.isAuthOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [generalDb.isAuthOpen]);

  if (!generalDb.isAuthOpen) return null;

  function onClose() {
    // Close the auth modal
    dispatch(closeAuth());
  }

  return (
    <div className="auth-overlay">
      <div className="auth-modal">
        {onClose && (
          <button className="auth-close" onClick={onClose}>
            ✕
          </button>
        )}
        {activeTab === "forgotpassword" && (
          <div className="forgot-password-tab">
            <button
              className="forgotpassword-back-button"
              onClick={() => setActiveTab("login")}
            >
              <FiArrowLeft size={24} />
            </button>
            <h3 className="no-line-height">
              <b>Forgot Password</b>
            </h3>
          </div>
        )}
        {activeTab != "forgotpassword" && !blockSignup && (
          <div className="auth-toggle">
            <button
              className={activeTab === "login" ? "active" : ""}
              onClick={() => setActiveTab("login")}
            >
              Login
            </button>

            <button
              className={activeTab === "signup" ? "active" : ""}
              onClick={() => setActiveTab("signup")}
            >
              Sign Up
            </button>
          </div>
        )}
        {activeTab === "login" ? (
          <Login setActiveTab={setActiveTab} />
        ) : activeTab === "signup" ? (
          blockSignup ? <Login setActiveTab={setActiveTab} /> : <Signup />
        ) : activeTab === "forgotpassword" ? (
          <ForgotPassword />
        ) : null}
      </div>
    </div>
  );
};

export default Auth;
